export default __webpack_public_path__ + "static/media/loginBG.5700a1ab.jpg";